<ul>
  <li (click)="handleClick($event, sharePlatformFacebook)">
    <div class="icon-container icon-container-facebook">
      <i class="icon icon-facebook"></i>
    </div> Facebook
  </li>

  <li (click)="handleClick($event, sharePlatformTwitter)">
    <div class="icon-container icon-container-twitter">
      <i class="icon icon-twitter"></i>
    </div> Twitter
  </li>

  <li (click)="handleClick($event, sharePlatformLinkedIn)">
    <div class="icon-container icon-container-linkedin">
      <i class="icon icon-linkedin"></i>
    </div> LinkedIn
  </li>

  <li (click)="handleClick($event, sharePlatformCopyLink)">
    <div class="icon-container icon-container-link">
      <i class="icon icon-link"></i>
    </div> Copy link <span class="copied" [@fadeInOut]="copyState" (@fadeInOut.done)="toggleCopyState()">Link copied!</span>
  </li>

  <li (click)="handleClick($event, sharePlatformEmail)">
    <div class="icon-container icon-container-email">
      <i class="icon icon-email"></i>
    </div> Email
  </li>
</ul>
